import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import BoxTextTile from './box-text-tile';

import styles from './boxText.module.less';

const BoxText = ({ tiles }) => {
  const renderedTiles = _.map(tiles, (tile, id) => (
    <BoxTextTile {...tile} key={id} />
  ));

  return <div className={styles.boxTextContainer}>{renderedTiles}</div>;
};

BoxText.displayName = 'Box Text';

BoxText.propTypes = {
  tiles: PropTypes.arrayOf(PropTypes.shape(BoxText.propTypes)),
  className: PropTypes.string,
  id: PropTypes.number,
};

export default BoxText;
